"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var ArrowDownIcon_1 = require("../Icons/ArrowDownIcon");
var Components_1 = require("../../utils/Components");
var AlertIcon_1 = require("../Icons/AlertIcon");
var Provider_1 = require("../Provider");
var allowedChildTypes = ['option', 'optgroup'];
var childValidator = function (child) {
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    if (!hasOwnProperty.call(child, 'props')) {
        // E.g. text nodes
        return true;
    }
    var element = child;
    return (typeof element.type === 'string' &&
        allowedChildTypes.indexOf(element.type) > -1);
};
var propTypes = {
    error: PropTypes.any,
    children: Components_1.childTreeValidator(childValidator, function (componentName) {
        return componentName + " can only contain (nested) children of type " + allowedChildTypes.join(', ');
    })
};
/**
 * The `Select` component is a wrapper for the HTML select element and should only
 * be used within a [FormRow component](#!/FormRow). The [SelectRow component](#!/SelectRow)
 * can be used as a shortcut for this combination.
 */
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Select.prototype.render = function () {
        // NOTE: Currently `multiple` is explicitly not allowed and will not be
        // passed to the HTML select element.
        // Once it has been decided how `multiple` should be treated, e.g. as a
        // ComboBox with checked items, this behaviour needs to be changed.
        var _a = this.props, children = _a.children, id = _a.id, className = _a.className, error = _a.error, multiple = _a.multiple, variant = _a.variant, other = __rest(_a, ["children", "id", "className", "error", "multiple", "variant"]);
        var componentClassName = classNames(className, 'ee_select');
        return (React.createElement("span", { className: componentClassName },
            React.createElement("select", __assign({ id: id, "data-focus-id": id, className: "ee_select__control", "aria-invalid": Boolean(error) }, other), children),
            React.createElement("span", { className: "ee_select__toggle-wrapper" },
                React.createElement(ArrowDownIcon_1.default, { className: "ee_select__toggle" })),
            Boolean(error) && (React.createElement(Provider_1.ErgoElementsContext.Consumer, null, function (context) {
                return context.theme === 'ergo' && (React.createElement("span", { className: "ee_select__error-icon-wrapper" },
                    React.createElement(AlertIcon_1.AlertIcon, { className: "ee_select__error-icon" })));
            }))));
    };
    Select.propTypes = propTypes;
    Select.defaultProps = {
        error: false
    };
    return Select;
}(react_1.Component));
exports.Select = Select;
exports.default = Select;
//# sourceMappingURL=Select.js.map
